import { Model } from '@vuex-orm/core'

export class NeurosurgeryProcedure extends Model {
  static entity = 'neurosurgeryProcedure'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      label: this.string(),
      diagnosisId: this.attr([]),
      icd10: this.string()
    }
  }
}
